import React from 'react';
import Select from 'react-select';
import { useSelector, useDispatch } from "react-redux";
import { setDataSource } from "../actions/searchAction";

//Ref: https://react-select.com/props

const options = [
  { value: 'Prod', label: 'Prod' },
  { value: 'Test', label: 'Test' },
]

export const DataSourceCombobox = (props) => {
  const state = useSelector((state) => state);
  const dispatch = useDispatch();

  return (
    <div>
      <Select
        options={options}
        defaultValue={{ label: `${state.dataSource}` }}
        onChange={(newValue, actionMeta) => dispatch(setDataSource(newValue.value))}
        styles={{
          menu: provided => ({ ...provided, zIndex: 9999 }) // Ensures dropdown appears above other content
        }}
      />
    </div>
  );
}
